export default {
  copy: 'copy',
  download: 'clowd-down'
}
